// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3yOir","title":"BackImages_title__3-uEL","images":"BackImages_images__3FK6b"};